import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import withWidth from '@mui/material/Hidden/withWidth'
import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useLocation, useNavigate } from 'react-router-dom'
import CustomTooltip from 'src/components/CustomTooltip/CustomTooltip'
import layoutStyles from 'src/components/Layout/styles/layoutStyles'
import PrivateContent from 'src/components/PrivateContent'
import {
  isAdmin,
  isAdministration,
  isDashBoardAvailable,
  isDataCustomizer,
  isDealer,
  isDealerOperator,
  isLooker,
  isOperator,
} from 'src/services/AccountService'
import { useAuth } from 'src/services/AuthProvider'
import { gState, setGState } from 'src/utils/controllers/GlobalStateController'
import { getStyles } from 'src/utils/utils/commonUtils'
import { getComp } from 'src/utils/utils/DI'
import arrow from '../../assets/images/common/arrow-down-custom.svg'
import { isAdminLabelAA, isSuperOperator } from '../../services/AccountService'
import { getSenderGroups } from '../../services/ApiService'
import webSocketService from '../../services/WebSocketService'
import commonStyles from '../../styles/commonStyles'
import stackActionsSelectStyles from '../../utils/components/StackActions/stackActionsSelectStyles'
import { disposeModal, regModal } from '../../utils/controllers/ModalController'
import store from '../../views/RequestsManagement/components/RequestsTableOptimized/RequestsTableOptimizedStore'
import Appbar from '../Appbar/Appbar'
import PageFooter from '../customElements/PageFooter'
import MainMenu from '../MainMenu/MainMenu'
import PhotoGalleryDialog from '../PhotoGalleryDialog/PhotoGalleryDialog'
import ProgressBackdrop from '../ProgressBackdrop/ProgressBackdrop'

function Layout() {
  const classes = {
    ...getStyles(layoutStyles),
    ...getStyles(commonStyles),
    ...getStyles(stackActionsSelectStyles),
  }
  const { logout } = useAuth()
  const intl = useIntl()
  const navigate = useNavigate()
  const location = useLocation()
  const statusStore = getComp('StatusesStore')

  useEffect(() => {
    getSenderGroups().then((data) => {
      statusStore.setSenderGroups(data)
    })
  }, [])
  const routesData = [
    {
      route: '/additional-summary',
      visible: isDashBoardAvailable,
      name: intl.formatMessage({ id: 'Инфографика' }),
    },
    {
      name: 'Заявки на установку',
      visible: () => !isAdministration(),
      menuChildren: [
        {
          route: '/requests',
          visible: () => true,
          name: intl.formatMessage({ id: 'Список заявок' }),
        },
        {
          route: '/reports',
          visible: () => isAdmin() || isDealer() || isDealerOperator(),
          name: intl.formatMessage({ id: 'Список отчетов' }),
          children: [
            {
              route: ':reportId',
              visible: () => isAdmin() || isDealer() || isDealerOperator(),
              name: isAdmin()
                ? intl.formatMessage({
                    id: 'Проверка отчётов',
                  })
                : intl.formatMessage({ id: 'Отчеты по заявкам на установку' }),
            },
          ],
        },
        {
          route: '/requests-archive',
          visible: () => isAdmin() && !isLooker(),
          name: intl.formatMessage({ id: 'Архив заявок' }),
        },
      ],
    },

    {
      name: 'Заявки на обслуживание',
      visible: () => !isAdministration() && !isOperator(),
      menuChildren: [
        {
          route: '/service',
          visible: () => !isOperator(),
          name: intl.formatMessage({ id: 'Список заявок' }),
        },
        {
          route: '/service-reports',
          visible: () => isAdmin() || isDealer() || isDealerOperator(),
          name: intl.formatMessage({
            id: 'Список отчетов',
          }),
          children: [
            {
              route: ':reportId',
              visible: () => isAdmin() || isDealer() || isDealerOperator(),
              name: 'Список отчетов',
            },
          ],
        },
      ],
    },
    {
      route: '/data-settings',
      visible: isDataCustomizer,
      name: intl.formatMessage({ id: 'Ввод оперативных данных' }),
    },
    {
      route: '/equipments',
      visible: () => (isAdmin() && !isLooker()) || isDealer(),
      name: intl.formatMessage({
        id: 'Управление оборудованием',
      }),
    },
    {
      route: '/similar-address',
      visible: () => isAdmin() && !isLooker(),
      name: intl.formatMessage({
        id: 'Управление дубликатами',
      }),
    },
    {
      name: 'Статистика',
      visible: () => isAdmin(),
      menuChildren: [
        {
          route: '/statistics',
          visible: isAdmin,
          name: intl.formatMessage({ id: 'Статистика заявок по добавлению' }),
        },
        {
          route: '/statistic-by-created-request',
          visible: () => isAdmin() && !isLooker(),
          name: intl.formatMessage({ id: 'Статистика по созданным заявкам' }),
        },
        {
          route: '/operational-summary',
          visible: () => isAdminLabelAA(),
          name: intl.formatMessage({ id: 'Статистика статусов заявок' }),
        },
        {
          route: '/installation-summary',
          visible: isAdmin,
          name: intl.formatMessage({ id: 'Статистика установок по регионам' }),
        },

        {
          route: '/reports-summary',
          visible: isAdmin,
          name: intl.formatMessage({ id: 'Статистика по отчётам дилеров' }),
        },
        {
          route: '/finances-summary',
          visible: () => isDataCustomizer(),
          name: intl.formatMessage({ id: 'Статистика установок по дотациям' }),
        },
        {
          route: '/summary-statistics-dealers',
          visible: () => isDataCustomizer(),
          name: intl.formatMessage({
            id: 'Сводная статистика установок по дилерам',
          }),
        },
        {
          route: '/summary-statistics-service',
          visible: () => isDataCustomizer(),
          name: intl.formatMessage({
            id: 'Сводная статистика ремонтов по регионам',
          }),
        },
        {
          route: '/application-service-statistics',
          visible: () => isDataCustomizer(),
          name: intl.formatMessage({ id: 'Статистика обслуживания заявок' }),
        },
      ],
    },
    {
      name: 'Управление и редактирование',
      visible: () => isAdmin(),
      menuChildren: [
        {
          route: '/customers',
          visible: () => isAdmin() && !isLooker(),
          name: intl.formatMessage({
            id: 'Управление Абонентами',
          }),
          children: [
            {
              route: ':customersId',
              visible: () => isAdmin() && !isLooker(),
              name: 'Управление Абонентам',
            },
          ],
        },
        {
          route: '/dealers-settings',
          visible: () => !isLooker() && isAdmin(),
          name: intl.formatMessage({ id: 'Управление дилерами' }),
        },
        {
          route: '/merge-cities',
          visible: () => !isLooker() && isAdminLabelAA(),
          name: intl.formatMessage({
            id: 'Редактор справочников населённых пунктов',
          }),
        },
        {
          route: '/editor',
          visible: () => isAdminLabelAA(),
          name: intl.formatMessage({
            id: 'Редактор дотационных населённых пунктов',
          }),
        },
      ],
    },

    {
      route: '/check-equipment-settings',
      visible: () => isDealer(),
      name: intl.formatMessage({ id: 'Проверка настроек оборудования' }),
    },

    {
      route: '/requests',
      visible: () => isAdministration(),
      name: intl.formatMessage({ id: 'Заявки на установку' }),
    },
    {
      route: '/service',
      visible: () => isAdministration(),
      name: intl.formatMessage({ id: 'Заявки на обслуживание' }),
    },

    {
      route: '/agreements',
      visible: () => isDealer(),
      name: intl.formatMessage({ id: 'Подтверждение договоров' }),
    },
    {
      onClick: logout,
      visible: () => true,
      name: intl.formatMessage({ id: 'Выход' }),
    },
  ]

  useEffect(() => {
    const loadAction = () => {
      fetch(`${window.location.origin}/version.json`)
        .then((res) => res.json())
        .then((res) => {
          window.SAT.config.version = res?.version
        })

      getComp('UserInfoStore')
        .load(navigate)
        .then(() => {
          if (isAdmin() || isAdministration() || isOperator()) {
            getComp('DealersStore').load()
          }
          if (isAdmin() || isSuperOperator()) {
            getComp('AuthorsStore').load()
            getComp('SourcesStore').load()
          }
          if (isDealer()) {
            getComp('DealerContractStore').reLoad()
          }
          getComp('TerritoryStore').load()
          getComp('SendersStore').load()
          getComp('CategoriesStore').load()
          getComp('InstallationReasonStore').load()
          getComp('PhotoSettingsStore').load()
          getComp('ProjectVersionStore').load()
          getComp('SourcesStore').load()

          webSocketService.setConnection()
        })
    }

    loadAction()

    setGState('navigate', navigate)

    return () => {
      webSocketService.disconnect()
      store.logout()
    }
  }, [])

  const { xBtn } = statusStore

  useEffect(() => {
    if (gState['roles']) {
      const link = document.getElementById('favicon')
      if (isAdmin()) {
        if (
          window.matchMedia &&
          window.matchMedia('(prefers-color-scheme: dark)').matches
        ) {
          link.href = '/adminsDarkFavicon.svg'
          return
        }
        link.href = '/adminsFavicon.svg'
      } else {
        link.href = '/favicon.png'
      }
    }
  }, [gState['roles']])

  const [showTopBtn, setShowTopBtn] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const modals = [
    'add-request',
    'request-details',
    'photo-gallery',
    'custom-tooltip',
    'transaction-confirmation',
  ]
  useEffect(() => {
    modals.forEach(regModal)
    return () => {
      modals.forEach(disposeModal)
    }
  }, [])

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 250) {
        setShowTopBtn(true)
      } else {
        setShowTopBtn(false)
      }
    }
    window.addEventListener('scroll', onScroll)

    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [])

  const toggleMenu = () => {
    setMenuOpen(!menuOpen)
  }
  const closeMenu = () => {
    setMenuOpen(false)
  }

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    statusStore.getFinancialSourceBack()
  }, [])

  useEffect(() => {
    goToTop()
  }, [location.pathname])

  return (
    <>
      {gState['roles'] && (
        <Box>
          <MainMenu
            open={menuOpen}
            toggleMenu={closeMenu}
            routesData={routesData}
          />
          <Appbar toggleMenu={toggleMenu} routesData={routesData} />
          <Box sx={classes.contentContainer}>
            <PrivateContent />
          </Box>
          <PageFooter />
          <PhotoGalleryDialog />
          <ProgressBackdrop />
          <CustomTooltip />
          <Button
            onClick={goToTop}
            color={'primary'}
            variant={'contained'}
            sx={{
              ...classes.topButton,
              ...classes.buttonActive,
              ...(showTopBtn ? classes.topButtonShow : {}),
              ...(isDealer() ? classes.hideOnMobile : {}),
              bottom:
                location.pathname === '/dealers-settings' ? '65px' : '200px',
            }}
          >
            <img
              draggable='false'
              src={arrow}
              alt={''}
              style={classes.topButtonImage}
            />
          </Button>
        </Box>
      )}
    </>
  )
}

export default withWidth()(observer(Layout))
